/* ============================================================================
  JMT Cart Count Refresh (UI ONLY)
  - Does NOT affect add-to-cart logic
  - Fetches /cart.js and updates:
    1) Header cart count (top corner)
    2) Pref-bar cart count (if present)
  - Listens to:
    - Custom event: jmt:cart:refresh
    - Fallback: intercepts fetch responses for /cart/add.js, /cart/change.js, /cart/update.js
============================================================================ */

(function () {
  'use strict';

  var CART_URL = '/cart.js';

  // --- Helpers ---------------------------------------------------------------

  function fetchCart() {
    return fetch(CART_URL, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  // Updates common Dawn/Spotlight patterns + your own if you add data hooks
  function updateHeaderCount(count) {
    // 1) Best practice hook (add this attribute to your header count element if you want)
    var hooked = document.querySelectorAll('[data-jmt-cart-count]');
    hooked.forEach(function (el) { el.textContent = String(count); });

    // 2) Theme/common selectors (safe no-ops if not found)
    var candidates = [
      '.header__icon--cart .cart-count-bubble span[aria-hidden="true"]',
      '.header__icon--cart .cart-count-bubble span',
      'a[href="/cart"] .cart-count-bubble span[aria-hidden="true"]',
      'a[href="/cart"] .cart-count-bubble span',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span'
    ];

    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) el.textContent = String(count);
    }

    // Some themes hide the bubble at 0
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      if (count > 0) bubble.removeAttribute('hidden');
      else bubble.setAttribute('hidden', '');
    }
  }

  function updatePrefBarCount(count) {
    // You can wire your pref bar count element with this attribute:
    // <span data-jmt-prefbar-cart-count>0</span>
    var els = document.querySelectorAll('[data-jmt-prefbar-cart-count]');
    els.forEach(function (el) { el.textContent = String(count); });

    // If you already have an element ID in the pref bar, add it here (optional):
    var legacy = document.getElementById('jmt-prefbar-cart-count');
    if (legacy) legacy.textContent = String(count);
  }

  function applyCounts(cart) {
    var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
    updateHeaderCount(count);
    updatePrefBarCount(count);

    try {
      document.dispatchEvent(new CustomEvent('jmt:cart:updated', { detail: { item_count: count } }));
    } catch (e) {}
  }

  var refreshTimer = null;
  function refreshSoon() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      fetchCart().then(applyCounts).catch(function () {});
    }, 120);
  }

  // --- Event listener hook ---------------------------------------------------

  document.addEventListener('jmt:cart:refresh', function () {
    refreshSoon();
  });

  // --- Fetch interception fallback ------------------------------------------

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0] && args[0].toString ? args[0].toString() : '';
      var p = _fetch.apply(this, args);

      // Only after successful cart mutations
      if (/\/cart\/(add|change|update)\.js/i.test(url)) {
        p.then(function (res) {
          if (res && res.ok) refreshSoon();
        }).catch(function () {});
      }
      return p;
    };
  }

  // Initial hydrate on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSoon);
  } else {
    refreshSoon();
  }
})();
